import { Alert, Button, Group } from '@mantine/core';
import { IconAlertCircle, IconRefresh } from '@tabler/icons-react';
import { errorMessage } from '@/lib/copy';

interface Props {
  error: unknown;
  title?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

/** Inline, plain-language error with an optional retry. Maps envelope errors and rule codes to copy. */
export function ErrorAlert({ error, title, onRetry, retryLabel = 'Try again' }: Props) {
  if (!error) return null;
  return (
    <Alert color="red" variant="light" icon={<IconAlertCircle size={18} />} title={title} role="alert" radius="md">
      {errorMessage(error)}
      {onRetry && (
        <Group mt="sm">
          <Button size="sm" variant="default" leftSection={<IconRefresh size={18} />} onClick={onRetry}>
            {retryLabel}
          </Button>
        </Group>
      )}
    </Alert>
  );
}
